import React, { Component } from 'react';

// import ExcelModule from './Excel';
// import LDIModule from './LDI';
// import XMIModule from './XMI';
// import SightProjectJSON from './SightProjectJSONModule';
import P6Module from './P6';
import '../../../styles/ImportDefaultTab.css';

class ImportDefaultTab extends Component {
  importModules = {
    // Excel: ExcelModule,
    // LDI: LDIModule,
    // XMI: XMIModule,
    // 'Sight Project (json)': SightProjectJSON,
    P6: P6Module,
  };

  moduleLookup(importModule) {
    return importModule ? this.importModules[importModule] : undefined;
  }

  onChange(e) {
    const importModule = e.target.value;

    if (importModule) {
      this.setState({
        moduleName: importModule,
      });
    }
  }

  state = {
    moduleName: null,
  };

  render() {
    const importModule = this.state.moduleName;
    const ImportModule = this.moduleLookup(importModule) || 'div';

    return (
      <div className="inner-tab-container">
        <div className="row tab-content">
          <span style={{ width: '100%' }}>
            <h1>Import</h1>
            <div className="row">
              <div className="col-md-2" />
              <div className="col-md-8">
                <fieldset className="form-group">
                  <label>Select Import Module</label>
                  <select
                    name="module"
                    className="form-control c-select"
                    onChange={::this.onChange}
                  >
                    <option value="">Select One...</option>
                    {
                      Object.keys(this.importModules).map((k) =>{
                        return (<option value={k}>{k}</option>)
                      })
                    }
                    e{' '}
                  </select>
                </fieldset>
                <ImportModule />
              </div>
              <div className="col-md-2" />
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default class ImportDefaultTabContainer extends Component {
  render() {
    return <ImportDefaultTab {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/Imports/Imports.js